import _ from 'lodash'

/** Why a request failed, in one line for a toast: the backend's text when it gave one. */
export function failureText(error: any): string {
  const info = _.get(error, 'response.data.info') ?? {}
  const details = info.details
  if (_.isString(details) && details) return details
  if (_.isObject(details) && !_.isEmpty(details)) return Object.values(details).join('; ')
  return info.message ?? 'Request failed'
}

/**
 * This backend answers some refusals (a record that is not there) with HTTP 200 and an `info.message`
 * other than "success". Throws an error shaped like an HTTP failure for such an answer, so the caller's
 * `catch` and `failureText` treat both kinds of refusal the same way.
 */
export function assertSucceeded(data: any): void {
  if (_.get(data, 'info.message') !== 'success') {
    throw Object.assign(new Error('The backend refused the request'), { response: { data } })
  }
}
